import { useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useMutation } from 'react-query';
import SingleBtn from 'components/common/elements/SingleBtn';
import LabelInput from 'components/common/forms/LabelInput';
import styles from 'styles/pages/mypage/CheckPassword.module.scss';
import { MypagePasswordCheckDefaultValues } from 'constants/mypage';
import { TMypageCheckPasswordForm } from 'types/form/mypage';
import { isTCustomAxiosError } from 'apis/config/axios';
import { postMypagePasswordCheck } from 'apis/mypage';

type TProps = {
  isChangePW?: boolean;
  setPasswordCheck: (value: boolean) => void;
};

const CheckPassword = ({ isChangePW, setPasswordCheck }: TProps) => {
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const methods = useForm<TMypageCheckPasswordForm>({
    defaultValues: MypagePasswordCheckDefaultValues,
  });
  const { handleSubmit } = methods;

  const password = useWatch({
    control: methods.control,
    name: 'password',
  });

  const { mutate: postMypagePasswordCheckMutation } = useMutation(
    'postMypagePasswordCheck',
    postMypagePasswordCheck,
    {
      onSuccess: () => {
        setPasswordCheck(true);
      },
      onError: (error) => {
        if (isTCustomAxiosError(error)) {
          if (error) {
            setErrorMsg(
              '비밀번호가 일치하지 않습니다. 입력한 정보를 다시 확인해 주세요.'
            );
          }
        }
      },
    }
  );

  const onValid = (data: TMypageCheckPasswordForm) => {
    postMypagePasswordCheckMutation({
      password: data.password,
    });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onValid)}>
        <div className="relative">
          <div className={styles.input_wrapper}>
            <LabelInput
              labelText="비밀번호"
              inputType="password"
              placeholderText="비밀번호를 입력해 주세요."
              name="password"
              rules={{ required: '비밀번호를 입력해 주세요.' }}
            />
            <div style={{ height: '22px' }}>
              {errorMsg && <p className={styles.error_msg}>{errorMsg}</p>}
            </div>
            <SingleBtn
              type="submit"
              btnText="확인"
              isBtnActive={true}
              btnStyle={{
                width: '384px',
                marginTop: '26px',
              }}
              disabled={!password}
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
export default CheckPassword;
